import { SortOrderType } from '@modules/shared/constants';
import get from 'lodash/get';
import { Dictionary } from '@modules/shared/models';

export class SortingUtils {
    static sortAllTagToFirstRow = (array: any) =>
        array.sort((a: any, b: any) => {
            const nameA = a.name || `${a.firstName} ${a.lastName}`;
            const nameB = b.name || `${b.firstName} ${b.lastName}`;
            if (nameA.toLowerCase() === 'all vessels') return -1;
            if (nameB.toLowerCase() === 'all vessels') return 1;
            return 0;
        });

    static defaultCompare = (property: string, order: SortOrderType): ((prevItem: any, nextItem: any) => number) => {
        return (prevItem: any, nextItem: any): SortOrderType => {
            if (!prevItem || !nextItem) {
                return order;
            }
            const prevValue = get(prevItem, property);
            const nextValue = get(nextItem, property);

            if (typeof prevValue === 'string' && typeof nextValue === 'string') {
                return SortingUtils.stringCompare(prevValue, nextValue, order);
            }

            if (!nextValue) return order;

            return prevValue > nextValue ? order : -order;
        };
    };

    static roleCompare = (
        property: string,
        order: SortOrderType,
        rolesMap: Dictionary<string>
    ): ((prevItem: any, nextItem: any) => number) => {
        return (prevItem: any, nextItem: any): SortOrderType => {
            if (!prevItem || !nextItem) {
                return order;
            }
            const prevValueArr = get(prevItem, property) || [];
            const nextValueArr = get(nextItem, property) || [];

            const prevValue = prevValueArr.map((id: string) => rolesMap[id]);
            const nextValue = nextValueArr.map((id: string) => rolesMap[id]);

            if (typeof prevValue === 'string' && typeof nextValue === 'string') {
                return SortingUtils.stringCompare(prevValue, nextValue, order);
            }

            if (!nextValue) return order;

            return prevValue > nextValue ? order : -order;
        };
    };

    static multiPropCompare = (order: SortOrderType, ...args: string[]): ((prevItem: any, nextItem: any) => number) => {
        return (prevItem: any, nextItem: any): SortOrderType => {
            if (!prevItem || !nextItem) {
                return order;
            }
            const prevValue = SortingUtils.combineProps(prevItem, ...args);
            const nextValue = SortingUtils.combineProps(nextItem, ...args);

            return SortingUtils.stringCompare(prevValue, nextValue, order);
        };
    };

    private static stringCompare = (prevValue: string, nextValue: string, order: SortOrderType): SortOrderType =>
        prevValue.toLowerCase() > nextValue.toLowerCase() ? order : -order;

    private static combineProps = (item: any, ...args: string[]) => {
        return args.reduce((result, property) => `${result} ${get(item, property)}`, '');
    };
}
